import { render, staticRenderFns } from "./SimpleGallery.vue?vue&type=template&id=f1acc0de"
import script from "./SimpleGallery.vue?vue&type=script&lang=js"
export * from "./SimpleGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Outputs/Images/SimpleGallery.vue
// module id = 1380
// module chunks = 31